<span class="tw-text-base tw-font-medium tw-leading-[125%] tw-text-dt-text-headings">
  {{ footerDescription }}
</span>
